import { FC } from 'react'
import { useTheme } from '@emotion/react'

// icons
import { icons } from '@/assets'
// hooks
import { useAppDispatch } from '@/hooks'
// features
import { reportCloseReportResolveModal } from '@/features'
// components
import { CardHeaderMobile, ModalCardTitle, ModalCardSubtitle, Error } from '@/components'

// components
import { ReportResolveForm } from './components'
// styles
import { styles } from './styles'

type ReportResolveCardProps = {}

export const ReportResolveCard: FC<ReportResolveCardProps> = () => {
  const theme = useTheme()

  const dispatch = useAppDispatch()
  const reportResolveError = ''

  return (
    <div
      css={styles(theme).card.main}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      {/* mobile header */}
      <div css={styles(theme).card.header}>
        <CardHeaderMobile
          onCloseClick={() => dispatch(reportCloseReportResolveModal())}
        />
      </div>

      {/* title */}
      <div css={styles(theme).card.title}>
        <ModalCardTitle text="Resolve" icon={icons.Check} />
      </div>

      {/* subtitle */}
      <div css={styles(theme).card.subtitle}>
        <ModalCardSubtitle text="Resolve the report once the matter has been thoroughly examined and processed." />
      </div>

      <div css={styles(theme).card.content.main}>
        {/* form */}
        <div css={styles(theme).card.content.form}>
          <ReportResolveForm />
        </div>

        <div css={styles(theme).card.content.error}>
          <Error error={reportResolveError} />
        </div>
      </div>
    </div>
  )
}

ReportResolveCard.propTypes = {}
